<template lang='pug' src='./form.pug'></template>

<script>
// this form DOES NOT USE the mailer at www.opsmiles.com / email.php
import axios from 'axios'
export default {
  data: () => {
    return {
      fullName: '',
      email: '',
      phone: '',
      location: '',
      message: '',
      formSubmitted: false,
      formSuccess: false,
      modalShowing: false
    }
  },
  methods: {
    validate () {
      this.$validator.validateAll()
      .then(result => {
        if (result) {
          this.onSubmit()
        }
      })
        .catch((e) => {
          console.log(e)
        })
    },
    closeModal () {
      this.formSuccess = false
      this.formSubmitted = false
      setTimeout(() => {
        this.modalShowing = false
      }, 150)
    },
    onSubmit () {
      this.formSubmitted = true
      const emailTemplate = `
        <!DOCTYPE html>
        <html>
        <body>
          <div class="container" style="background-color: #ebf5ff; padding: 1.5rem 0;">
            <div style="padding: 2rem 0; margin: 0 auto;"><img style="width: auto; height: 6rem; display: block; margin-left: auto; margin-right: auto; margin-bottom: 1rem;" src="https://www.roostergrin.com/wp-content/uploads/2019/11/rg-logo.png">
              <h1 style="font-size: 40px; margin: 0; text-align: center; width: 100%; color: #003b75;">Form Received!</h1></div>
          </div>
          <div class="section" style="background-color: #fdfdfd;">
            <div class="container" style="padding: 4rem 32px 1rem 32px; max-width: 1440px; margin: 0 auto">
              <p>first name: ${this.fullName}</p>
              <p>email: ${this.email}</p>
              <p>phone: ${this.phone}</p>
              <p>location: ${this.location}</p>
              <p>message: ${this.message}</p>
            </div>
          </div>
            <div class="container" style="padding: 0 32px 4rem 32px; max-width: 1440px; margin: 0 auto">
              <p style="color: #3f3f3f;">This info was submitted to your form at <a href="https://www.opsmiles.com/">https://www.opsmiles.com/</a>.</p>
            </div>
          </div>
        </body>
        </html>
      `
      axios.post('https://aamuwi383c.execute-api.us-west-1.amazonaws.com/prod/roostergrin-emailer', null, {
        params: {
          subject: `opsmiles.com - Contact Form`,
          from: `no-reply@opsmiles.com`,
          // two email addresses are written as:'matt.sprague@roostergrin.com:second.email@example.com'
          to: `ortho@opsmiles.com`,
          body: emailTemplate
        },
        headers: {
          'Content-Type': 'application/json'
        }
      })
      .then(res => {
        this.formSuccess = true
        setTimeout(() => {
          window.location.href = 'https://www.opsmiles.com/thank-you'
        }, 400)
        setTimeout(() => {
          this.fullName = ''
          this.email = ''
          this.phone = ''
          this.location = ''
          this.message = ''
        }, 1000)
        setTimeout(() => {
          this.errors.clear()
        }, 1100)
      })
      .catch(e => {
        console.log(e, 'submitted')
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// form.vue?49611e91